// components/business/message-container/components/box/chat-msg-box/chat-msg-box.js
Component({
    /**
     * 组件的属性列表
     */
    properties: {
        msg: {
            type: Object,
            value: {},
            observer: function (msg) {
                let feature = msg.feature || {};
                if (typeof msg.feature == "string") {
                    feature = JSON.parse(msg.feature || "{}");
                }
                const data = { feature };
                if (msg.subType === 3) {
                    data.duration = (feature["du"] || 0) * 1000;
                }
                this.setData(data);
            },
        },
        // 展示所有图片消息集合
        imgUrls: {
            type: Array,
            value: [],
        },
    },

    /**
     * 组件的初始数据
     */
    data: {
        duration: 0,
        feature: {},
    },

    /**
     * 组件的方法列表
     */
    methods: {},
});
